"use client"

import dynamic from "next/dynamic"

const CookieConsentCmp = dynamic(() => import("@repo/ui/cookie-consent"), {
	ssr: false,
})

const PageTracker = dynamic(() => import("@repo/ui").then((mod) => ({ default: mod.PageTracker })), {
	ssr: false,
})

/**
 * 延迟加载的非首屏组件容器
 */
export default function DeferredComponents() {
	return (
		<>
			<CookieConsentCmp />
			<PageTracker />
		</>
	)
}

/**
 * Google Analytics 组件（需在 </body> 之后、</html> 之前渲染）
 */
export function DeferredGoogleAnalytics({ gaId }: { gaId: string }) {
	const GoogleAnalytics = dynamic(
		() => import("@next/third-parties/google").then((mod) => ({ default: mod.GoogleAnalytics })),
		{ ssr: false }
	)
	return <GoogleAnalytics gaId={gaId} />
}
